<template>
    <div class="signup">
        <h2>Bevestig uw e-Mail adres</h2>
        <p>We hebben u een e-mail met daarin een bevestigingscode gestuurd.</p>
        <p>Voer hieronder deze code in om uw e-mail adres te bevestigen</p>

        <div class="alert alert-danger" v-if="errorMessage">{{errorMessage}}</div>

        <div class="form-inline">
            <div class="form-group" v-if="!bLoading">

                <PincodeInput :length="pincodeLength"
                              placeholder="0" v-model="confirmCode" :class="{invalid: $v.confirmCode.$invalid}"
                              @change="$v.confirmCode.$touch()" v-on:input="submit"/>
                <div v-if="$v.confirmCode.$error">
                    <p class="help has-text-light" v-if="!$v.confirmCode.required">
                        Veld is vereist</p>
                    <p class="help has-text-light" v-if="!$v.confirmCode.numeric">
                        Veld mag alleen numerieke waardes bevatten</p>
                    <p class="help has-text-light" v-if="!$v.confirmCode.minLength || !$v.confirmCode.maxLength">
                        Alle velden moeten worden ingevuld</p>
                </div>
            </div>
        </div>
        <div class="loader" id="loader-1" v-if="bLoading"></div>
    </div>

</template>

<script>
  import { validation } from '../mixins/confirm-validations'
  import PincodeInput from 'vue-pincode-input'

  export default {
    name: 'Confirm',
    mixins: [validation],
    components: {
      PincodeInput
    },
    data () {
      return {
        pincodeLength: 5,
        confirmCode: '',
        bLoading: false,
        errorMessage: false,
        bSubmitted: false
      }
    },
    methods: {
      requestFailed (e) {
        this.bLoading = false
        alert('an error occured while processing the request: ' + e)
      },
      submit () {
        const isValid = this.validate()
        if (isValid && !this.bSubmitted) {
          this.bLoading = true
          this.bSubmitted = true
          this.$http.post('/signup/wizard/confirm', {
            'ConfirmForm':
              {
                code: this.confirmCode,
              }
          })
            .then(request => this.parseConfirmResponse(request))
            .catch(() => this.requestFailed())
        }
      },
      parseConfirmResponse (req) {
        this.bLoading = false
        if (req.status !== 200) {
          this.bLoading = false
          this.confirmCode = ''
          alert('an error occurred')
          this.requestFailed(req)
          return false
        }
        if (req.data.error) {
          this.confirmCode = ''
          this.errorMessage = 'Ongeldige bevestigingscode'
          return false
        }
        if (req.data !== false && typeof req.data === 'string') {
          this.bLoading = true
          this.$store.commit('setConfirmed')
          this.$store.commit('setAccessToken', req.data)
          this.$emit('accountConfirmed')
        }

        // const data = req.data;
      },
      validate () {
        this.errorMessage = ''
        this.$v.$touch()
        let isValid = true

        this.fields.forEach((field) => {
          if (this.$v[field].$invalid) {
            isValid = false
          }
        })

        return isValid
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .signup {
        margin: auto auto;
        max-width: 480px;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

</style>
